import {
  Box,
  Flex,
  Image,
  Stack,
  Text,
  VStack,
  Grid,
} from "@chakra-ui/react";
import React from "react";

const ExamSolvedQuestions = ({
  data,
  answers,
  selectedQuestionIdx,
  correctionArr,
}) => {
  const baseUrl = "https://asquera.com/asquera";
  const filteredAnswers = correctionArr?.filter(
    (val) => val?.question_id == data?.id
  );
  const answersTypes = {
    wrong: { color: "gray.300", msg: "Your Answer" },
    correct: { color: "green", msg: "Correct Answer" },
    normal: "transparent",
  };

  const isExamResult = window.location.pathname.includes("exam-result");
  const hasEssayMeta =
    isExamResult &&
    data &&
    Object.prototype.hasOwnProperty.call(data, "student_answer_id") &&
    Object.prototype.hasOwnProperty.call(data, "teacher_grade");
  const isPendingEssay =
    hasEssayMeta &&
    data.student_answer_id == null &&
    data.teacher_grade == null;
  const isGradedEssay =
    hasEssayMeta &&
    data.student_answer_id == null &&
    data.teacher_grade != null;
  const essayAnswer = filteredAnswers?.[0]?.essay_answer;
  const essayComment = String(
    data?.comment ?? filteredAnswers?.[0]?.comment ?? ""
  ).trim();
  const essayScoreColor = data?.wrong == 1 ? "red.600" : "green.600";
  const essayScoreBorder = data?.wrong == 1 ? "red.400" : "green.400";
  const essayScoreBg = data?.wrong == 1 ? "red.50" : "green.50";

  const handelAnswer = (val) => {
    if (
      filteredAnswers[0]?.student_answer_id == val?.id &&
      val?.right_answer == 1
    )
      return "correct";
    else if (
      filteredAnswers[0]?.student_answer_id == val?.id &&
      val?.right_answer == 0
    )
      return "wrong";
    else if (val?.right_answer == 1) return "correct";
    else return "normal";
  };

  return (
    <VStack w="100%" spacing="40px">
      {/* question */}
      <Box
        w="100%"
        bg="white"
        border="1px solid"
        borderColor="gray.300"
        borderRadius="12px"
        p={6}
        boxShadow="0 2px 8px rgba(0,0,0,0.08)"
      >
        <Stack
          flexDirection={{ base: "column", lg: "row" }}
          spacing={{ base: 4, lg: 6 }}
          alignItems="flex-start"
        >
          <VStack 
            w={{ base: "100%", lg: data?.image && data?.image != "null" ? "60%" : "100%" }} 
            alignItems="flex-start"
            spacing={4}
          >
            {data?.comprehension && (
              <Box w="100%">
                <Text
                  fontSize="18px"
                  fontWeight="700"
                  textDecoration="underline"
                  mb={2}
                  color="gray.800"
                >
                  Comprehension
                </Text>
                <Text 
                  fontSize="16px" 
                  color="gray.700"
                  lineHeight="1.6"
                  whiteSpace="pre-wrap"
                >
                  {data?.comprehension}
                </Text>
              </Box>
            )}
            <Box w="100%">
              <Text
                fontSize="18px"
                fontWeight="700"
                textDecoration="underline"
                mb={2}
                color="gray.800"
              >
                Question
              </Text>
              <Box
                fontSize="16px"
                color="gray.800"
                lineHeight="1.6"
                sx={{
                  '& p': {
                    margin: 0,
                  },
                  '& *': {
                    maxWidth: '100%',
                  }
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: data?.question }} />
              </Box>
            </Box>
          </VStack>

          {data?.image && data?.image != "null" && (
            <Box flex={1} display="flex" justifyContent="center" alignItems="flex-start">
              <Image
                src={`${baseUrl}/${data?.image}`}
                w={{ base: "100%", lg: "auto" }}
                maxH="400px"
                objectFit="contain"
                borderRadius="8px"
              />
            </Box>
          )}
        </Stack>
      </Box>

      {/* essay result */}
      {isPendingEssay && (
        <Box
          w="100%"
          p={6}
          borderRadius="12px"
          border="2px solid"
          borderColor="yellow.400"
          bg="yellow.50"
        >
          <Text fontSize="18px" fontWeight="700" color="yellow.700">
            Pending score
          </Text>
          <Text fontSize="18px" fontWeight="700" color="yellow.700" dir="rtl">
            درجة قيد الانتظار
          </Text>
          <Text fontSize="15px" color="gray.700" mt={1}>
            This essay question has not been corrected yet.
          </Text>
          <Text fontSize="15px" color="gray.700" dir="rtl">
            لم يتم تصحيح سؤال المقال بعد.
          </Text>
          {essayAnswer && (
            <Text fontSize="16px" color="gray.800" mt={4} whiteSpace="pre-wrap">
              {essayAnswer}
            </Text>
          )}
          {essayComment && (
            <Box mt={4} p={3} bg="white" borderRadius="8px">
              <Text fontSize="14px" fontWeight="700" color="gray.700">
                Comment
              </Text>
              <Text fontSize="14px" fontWeight="700" color="gray.700" dir="rtl">
                تعليق
              </Text>
              <Text fontSize="16px" color="gray.800" mt={1} whiteSpace="pre-wrap" dir="rtl">
                {essayComment}
              </Text>
            </Box>
          )}
        </Box>
      )}

      {isGradedEssay && (
        <Box
          w="100%"
          p={6}
          borderRadius="12px"
          border="2px solid"
          borderColor={essayScoreBorder}
          bg={essayScoreBg}
        >
          <Text fontSize="18px" fontWeight="700" color={essayScoreColor}>
            Score: {data.teacher_grade} / {data?.mark}
          </Text>
          <Text fontSize="18px" fontWeight="700" color={essayScoreColor} dir="rtl">
            الدرجة: {data.teacher_grade} / {data?.mark}
          </Text>
          {essayAnswer && (
            <Text fontSize="16px" color="gray.800" mt={4} whiteSpace="pre-wrap">
              {essayAnswer}
            </Text>
          )}
          {essayComment && (
            <Box mt={4} p={3} bg="white" borderRadius="8px">
              <Text fontSize="14px" fontWeight="700" color="gray.700">
                Comment
              </Text>
              <Text fontSize="14px" fontWeight="700" color="gray.700" dir="rtl">
                تعليق
              </Text>
              <Text fontSize="16px" color="gray.800" mt={1} whiteSpace="pre-wrap" dir="rtl">
                {essayComment}
              </Text>
            </Box>
          )}
        </Box>
      )}

      {/* answers */}
      {!isPendingEssay && !isGradedEssay && (
      <Box w="100%">
        <Grid
          role="group"
          aria-labelledby="my-radio-group"
          templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }}
          gap={3}
          w="100%"
        >
          {data?.answers?.map((val, index) => {
            const letter = String.fromCharCode(65 + index); // A, B, C, D
            const answerType = handelAnswer(val);
            const isCorrect = val?.right_answer == 1;
            const isStudentAnswer = filteredAnswers[0]?.student_answer_id == val?.id;
            
            // Determine border and background colors
            let borderColor = "gray.300";
            let bgColor = "white";
            let letterBg = "gray.200";
            let letterColor = "gray.700";
            
            if (answerType === "correct") {
              borderColor = "green.500";
              bgColor = isStudentAnswer ? "green.50" : "white";
              letterBg = "green.500";
              letterColor = "white";
            } else if (answerType === "wrong") {
              borderColor = "red.500";
              bgColor = "red.50";
              letterBg = "red.500";
              letterColor = "white";
            } else if (isCorrect) {
              borderColor = "green.500";
              bgColor = "white";
              letterBg = "green.500";
              letterColor = "white";
            }
            
            return (
              <Box key={val?.id} w="100%">
                <Flex
                  w="100%"
                  alignItems="center"
                  p={4}
                  borderRadius="12px"
                  border="2px solid"
                  borderColor={borderColor}
                  bg={bgColor}
                  boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                >
                  <Box
                    w="40px"
                    h="40px"
                    borderRadius="50%"
                    border="2px solid"
                    borderColor={borderColor}
                    bg={letterBg}
                    color={letterColor}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="bold"
                    fontSize="18px"
                    mr={3}
                    flexShrink={0}
                  >
                    {letter}
                  </Box>
                  <Text fontSize="18px" flex={1} lineHeight="1.5">
                    {val?.answer}
                  </Text>
                  {answersTypes[answerType]?.msg && (
                    <Text
                      fontSize="14px"
                      fontWeight="600"
                      color={answerType === "correct" ? "green.600" : "red.600"}
                      ml={2}
                      flexShrink={0}
                    >
                      [{answersTypes[answerType]?.msg}]
                    </Text>
                  )}
                </Flex>
              </Box>
            );
          })}
        </Grid>
      </Box>
      )}
    </VStack>
  );
};

export default ExamSolvedQuestions;
